// broadcast-overlay.component.ts
import { Component, OnInit, OnDestroy } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { RestClientService } from '@core/service/rest-client.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import moment from 'moment';
import { AuthService } from '@core';

interface BroadcastMessage {
  id: string;
  libelle: string;
  message: string;
  date?: string;
  image_url?: string;
  [key: string]: any;
}

@Component({
  selector: 'app-broadcast-overlay',
  templateUrl: './broadcast-overlay.component.html',
  styleUrls: ['./broadcast-overlay.component.scss'],
  imports: [CommonModule, FormsModule],
  animations: [
    trigger('slideDown', [
      state('void', style({ transform: 'translateY(-100%)', opacity: 0 })),
      state('*', style({ transform: 'translateY(0)', opacity: 1 })),
      transition('void => *', animate('300ms ease-out')),
      transition('* => void', animate('300ms ease-in'))
    ]),
    trigger('fadeIn', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('300ms', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        animate('300ms', style({ opacity: 0 }))
      ])
    ])
  ]
})
export class BroadcastOverlayComponent implements OnInit, OnDestroy {
  messages: BroadcastMessage[] = [];
  displayText: string = '';
  isVisible: boolean = false;
  showDetail: boolean = false;
  selectedMessage: BroadcastMessage | null = null;
  showImageViewer: boolean = false;
  currentImage: string = '';
  isAuth: boolean = false;

  constructor(private restClient: RestClientService, private authService: AuthService) {
    this.isAuth = this.authService.isAuth()
  }

  ngOnInit() {
    this.getBroadcastMessages();
  }

  ngOnDestroy() {
    // Clean up if needed
  }

  getBroadcastMessages() {
    const request = {
      index: 0,
      size: 1000,
      filter_inf: {
        key: 'date_fin',
        value: moment(),
      },
      filter_sup: {
        key: 'date_effet',
        value: moment()
      },
      is_for_pretataire_message: true,
      data: {}
    };

    this.restClient.post('messageBroadcast/getByCriteria', request).subscribe(
      (res: any) => {
        if (res && !res['hasError'] && res['items'] && res.items.length) {
          this.messages = res.items;
          this.displayText = this.messages
            .map((it: BroadcastMessage) => `${it.libelle}: ${it.message}`)
            .join(' | ');
          this.isVisible = true;
        } else {
          this.isVisible = false;
        }
      },
      (error) => {
        console.error('Error fetching broadcast messages:', error);
        this.isVisible = false;
      }
    );
  }

  closeOverlay() {
    this.isVisible = false;
    this.showDetail = false;
  }

  showOverlay() {
    this.isVisible = true;
    this.isAuth = this.authService.isAuth()
  }

  openDetail() {
    this.showDetail = true;
  }

  closeDetail() {
    this.showDetail = false;
    this.selectedMessage = null;
  }

  viewMessageDetail(message: BroadcastMessage) {
    this.selectedMessage = message;
  }

  backToList() {
    this.selectedMessage = null;
  }

  viewImage(imageUrl: string) {
    this.currentImage = imageUrl;
    this.showImageViewer = true;
  }

  closeImageViewer() {
    this.showImageViewer = false;
    this.currentImage = '';
  }
}